import { render, staticRenderFns } from "./NotificationsEv.vue?vue&type=template&id=422bc14c"
import script from "./NotificationsEv.vue?vue&type=script&lang=js"
export * from "./NotificationsEv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports